// ===============================================
// 🗂️ SIDEBAR ADMINISTRATIVA
// ===============================================
// Arquivo: src/components/admin/AdminSidebar.js

import React, { memo, useMemo } from 'react';
import { useAuth } from '../../context/AuthContext';
import './AdminSidebar.css';

const AdminSidebar = memo(({ activeMenu, onMenuChange, collapsed = false, onToggleCollapse }) => {
  const { user } = useAuth();

  const menuItems = useMemo(() => [
    {
      id: 'gestao',
      icon: '📦',
      label: 'GESTÃO',
      description: 'Gestão de expedição'
    },
    {
      id: 'relatorios',
      icon: '📊',
      label: 'Relatórios',
      description: 'Relatórios do sistema'
    },
    {
      id: 'configuracoes',
      icon: '⚙️',
      label: 'Configurações',
      description: 'Configurações gerais'
    }
  ], []);

  return (
    <div
      className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}
      onClick={onToggleCollapse}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggleCollapse?.();
        }
      }}
      title={collapsed ? 'Clique para expandir o menu' : 'Clique para recolher o menu'}
    >
      <span className="admin-sidebar-chevron" aria-hidden="true">
        {collapsed ? '›' : '‹'}
      </span>

      {/* Header */}
      <div className="admin-sidebar-header">
        <div className="admin-logo">
          <span className="logo-icon">👑</span>
          <div className="logo-text">
            <h2>Admin</h2>
            <p>Painel Administrativo</p>
          </div>
        </div>
        <div className="admin-user-info">
          <div className="user-avatar">
            {user?.nome?.charAt(0).toUpperCase() || 'A'}
          </div>
          <div className="user-details">
            <span className="user-name">{user?.nome || 'Administrador'}</span>
            <span className="user-role">{user?.cargo || 'admin'}</span>
          </div>
        </div>
      </div>

      {/* Menu Items */}
      <div className="admin-sidebar-menu">
        <div className="menu-section">
          <span className="menu-section-title">MENU</span>
          {menuItems.map(item => (
            <button
              key={item.id}
              className={`menu-item ${activeMenu === item.id ? 'active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                onMenuChange(item.id);
              }}
              title={collapsed ? item.label : undefined}
            >
              <span className="menu-icon">{item.icon}</span>
              <div className="menu-content">
                <span className="menu-label">{item.label}</span>
                <span className="menu-description">{item.description}</span>
              </div>
              {activeMenu === item.id && (
                <span className="menu-indicator">▶</span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Footer */}
      <div className="admin-sidebar-footer">
        <div className="system-info">
          <div className="info-item">
            <span className="info-icon">📦</span>
            <span className="info-text">Sistema PCP v3.2.1</span>
          </div>
          <div className="info-item">
            <span className="info-icon">💻</span>
            <span className="info-text">Desenvolvido por Indalécio Júlio</span>
          </div>
        </div>
      </div>
    </div>
  );
});

AdminSidebar.displayName = 'AdminSidebar';
export default AdminSidebar;
